import Snippet from "../../../../contents/docs/integrate/_snippets/install-js-snippet.mdx";
import * as React from 'react';
export default {
  Snippet,
  React
};